import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ui-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadioComponent),
            multi: true,
        }],
    standalone: false
})
export class RadioComponent implements OnInit, ControlValueAccessor {
  @Input('p-id') id: string;
  @Input('p-value') value: string;
  @Input('p-checked') checked: boolean = false;
  @Input('p-error') error: boolean = false;
  @Input('p-label') label: string | null = null;

  public onChangeCallback: (value: any) => void;
  public onTouchedCallback: (value: any) => void;

  constructor() {
  }

  ngOnInit(): void {
  }

  public writeValue(newValue: boolean) { }

  public registerOnChange(onChangeCallback: any): void {
    this.onChangeCallback = onChangeCallback;
  }

  public registerOnTouched(onTouchedCallback: any): void {
    this.onTouchedCallback = onTouchedCallback;
  }

  update() {
    this.onChangeCallback(this.value);
  }
}
